var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{staticClass:"my-overlay",attrs:{"value":_vm.isLoading}},[_c('v-card',{staticClass:"screen-center",attrs:{"width":"500"}},[_c('v-progress-linear',{attrs:{"indeterminate":"","height":"10","color":"yellow darken-2"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }